require('../../modules/es6.number.is-safe-integer');
module.exports = require('../../modules/$.core').Number.isSafeInteger;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-safe-integer.js
// module id = 1219
// module chunks = 0